import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Typography,
  Input,
  Button,
  Table,
  message,
  Popconfirm,
} from "antd";
import moment from "moment";
import { platformApi } from "../../../api";
import { ContextAPI } from "../../../ContextAPI";
import VehicleName from "../../VehicleName";

const { Title } = Typography;
const { Search } = Input;

export default function LabourPerformList() {
  const history = useHistory();
  const { loginCredintials } = useContext(ContextAPI);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");
  const [spinning, setSpinning] = useState(false);
  // Popconfirm OK is portaled — click can hit the row after delete; block that navigation
  const blockRowClickRef = useRef(false);

  const createAccess =
    loginCredintials?.roleAccess?.some(
      (each) => each.subModule === "labour_perform" && each.access?.create
    ) ?? false;
  const modifyAccess =
    loginCredintials?.roleAccess?.some(
      (each) => each.subModule === "labour_perform" && each.access?.update
    ) ?? false;
  const deleteAccess =
    loginCredintials?.roleAccess?.some(
      (each) => each.subModule === "labour_perform" && each.access?.delete
    ) ?? false;

  const fetchPage = (pg = page, searchString = search) => {
    setSpinning(true);
    platformApi
      .post("/api/materialIssue/get", {
        page: pg,
        size: limit,
        searchString: searchString || "",
        type: "labour_perform",
      })
      .then((res) => {
        setSpinning(false);
        if (res?.data?.code === 200 && res.data.response?.code === 200) {
          setData(res.data.response.data?.materialIssue || []);
          setCount(res.data.response.data?.count || 0);
        } else {
          message.error("Unable to fetch Labour Perform records");
        }
      })
      .catch(() => {
        setSpinning(false);
        message.error("Unable to fetch Labour Perform records");
      });
  };

  useEffect(() => {
    fetchPage(1, "");
  }, []);

  const columns = [
    {
      title: "Job No",
      render: (r) => r.job?.jobNo || "-",
    },
    {
      title: "Customer Name",
      render: (r) => r.job?.customer?.name || "-",
    },
    {
      title: "Model",
      width: 260,
      render: (r) => (
        <VehicleName
          nameOnly
          value={r.job?.vehicle?.vehicle}
          fallback="-"
        />
      ),
    },
    {
      title: "Issue Date",
      render: (r) =>
        r.issueDate ? moment(r.issueDate).format("DD-MM-YYYY") : "-",
    },
    {
      title: "Net Amount",
      render: (r) => r.netAmount ?? "-",
    },
    {
      title: "Action",
      render: (r) => (
        <span onClick={(e) => e.stopPropagation()}>
          {modifyAccess && (
            <span
              className="linkylink"
              onClick={(e) => {
                e.stopPropagation();
                history.push({
                  pathname: `/autoadmin/labour_perform/${r.id}`,
                  state: { editMode: true },
                });
              }}
            >
              Modify
            </span>
          )}
          {modifyAccess && deleteAccess && <span> | </span>}
          {deleteAccess && (
            <Popconfirm
              title="Delete this record?"
              onCancel={(e) => {
                if (e && e.stopPropagation) e.stopPropagation();
              }}
              onConfirm={(e) => {
                if (e && e.stopPropagation) e.stopPropagation();
                blockRowClickRef.current = true;
                platformApi
                  .delete(`/api/materialIssue/${r.id}`)
                  .then((res) => {
                    if (res?.data?.code === 200) {
                      message.success("Deleted");
                      fetchPage(page, search);
                    } else message.error("Delete failed");
                  })
                  .catch(() => message.error("Delete failed"))
                  .finally(() => {
                    setTimeout(() => {
                      blockRowClickRef.current = false;
                    }, 400);
                  });
              }}
            >
              <span
                className="linkylink"
                onClick={(e) => e.stopPropagation()}
              >
                Delete
              </span>
            </Popconfirm>
          )}
        </span>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <Title level={4}>Labour Perform [{count}]</Title>
        <div style={{ display: "flex", gap: 8 }}>
          <Search
            placeholder="Search Labour Perform"
            onSearch={(v) => {
              setSearch(v);
              setPage(1);
              fetchPage(1, v);
            }}
            style={{ width: 280 }}
          />
          {createAccess && (
            <Button
              type="primary"
              onClick={() => history.push("/autoadmin/labour_perform/:id")}
            >
              Add Labour Perform
            </Button>
          )}
        </div>
      </div>
      <Table
        loading={spinning}
        rowKey="id"
        columns={columns}
        dataSource={data}
        onRow={(record) => ({
          onClick: () => {
            if (blockRowClickRef.current) return;
            history.push(`/autoadmin/labour_perform/${record.id}`);
          },
        })}
        pagination={{
          current: page,
          pageSize: limit,
          total: count,
          onChange: (p) => {
            setPage(p);
            fetchPage(p, search);
          },
        }}
      />
    </div>
  );
}
